// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"179":"main","532":"styles"}[chunkId] + "." + {"179":"9eab8081ba4860d1acdc","532":"378e682382abbaf1e5c6"}[chunkId] + ".css";
};